import React from "react";
import { match as matchPropTypes } from "react-router-prop-types";
import { CSSTransitionGroup } from "react-transition-group";
import PageTitle from "src/Layout/AppMain/PageTitle";
import __ from "src/utils/Translations";
import { useCompanyId } from "src/Pages/Company/CompanyContext";
import ImportsList from "./list";

export default function List({ match }) {
  const companyId = useCompanyId();

  return (
    <>
      <CSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <PageTitle heading={`${__("Historia importów")}`} breadcrumbs={[]} />
        <ImportsList companyId={companyId} />
      </CSSTransitionGroup>
    </>
  );
}

List.propTypes = {
  match: matchPropTypes.isRequired,
};
